import { enumHorzCentering, enumVertCentering } from "../constants";
import { QElement } from "./QElement";

export class QBoxOverlay extends QElement {
  constructor() {
    super();
    this.fChartBox = null;
    this.fDeltaDefX = -10;
    this.fDeltaDefY = 10;
    this.fOverrideWidth = null;
    this.fIconSize = null;
    this.fVPosition = enumVertCentering.pinBottom;
    this.fHPosition = enumHorzCentering.pinRight;
  }

  InitBoxOverlay(chartBox) {
    this.fChartBox = chartBox;
    this.SetPinLocation();
    this.SetLayer(chartBox.GetLayer());
  }

  SetPinLocation() {
    const isPositionDoc = this.fChartBox?.GetDoc().IsPositionDocument();

    if (isPositionDoc) {
      if (this.fChartBox.IsPositionBox()) {
        this.fVPosition = enumVertCentering.pinTop;
        this.fHPosition = enumHorzCentering.pinLeft;
      } else {
        this.fVPosition = enumVertCentering.centermiddle;
        this.fHPosition = enumHorzCentering.pinRight;
      }
    } else {
      this.fVPosition = enumVertCentering.pinBottom;
      this.fHPosition = enumHorzCentering.pinRight;
    }
  }

  GetAssociatedBox() {
    return this.fChartBox;
  }

  DoRenderElement(drawBuffer) {
    // Override me please
  }

  SetOverrideWidth(theWidth) {
    this.fOverrideWidth = theWidth;
  }

  SetIconSize(size) {
    this.fIconSize = size;
  }

  DoAltRender(altCanvas) {
    // Override me please
  }
}
